import { get } from '@rails/request.js';
import { createPopper } from '@popperjs/core';
import { Controller } from '@hotwired/stimulus';

var __async$5 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getHTML(url) {
  return __async$5(this, null, function* () {
    const response = yield get(url, { headers: { "X-Shimmer": "true" } });
    if (response.ok) {
      return yield response.response.text();
    }
    return "";
  });
}
new Promise((res) => {
  document.addEventListener("DOMContentLoaded", () => {
    res();
  });
});
function nextFrame() {
  return __async$5(this, null, function* () {
    return new Promise((res) => {
      setTimeout(res, 10);
    });
  });
}
function createElement(parent, className) {
  const element = document.createElement("div");
  element.className = className;
  parent.append(element);
  return element;
}
function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  }
  return [s4() + s4(), s4(), s4(), s4(), s4() + s4() + s4()].join("-");
}
function wait(seconds) {
  return new Promise((res) => {
    setTimeout(res, seconds * 1e3);
  });
}
function getCookie(key) {
  var _a;
  if (!document.cookie)
    return null;
  return (_a = document.cookie.split(";").map((v) => v.split("=")).reduce((acc, v) => {
    acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
    return acc;
  }, {})[key]) != null ? _a : null;
}
function setCookie(key, value) {
  const date = new Date();
  date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1e3);
  document.cookie = `${key}=${value}; expires=${date.toUTCString()}`;
}

var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class ModalPresenter {
  constructor() {
    this.modals = {};
    this.prepareBlind = () => {
      createElement(document.body, "modal-blind");
    };
    document.addEventListener("turbo:load", this.prepareBlind);
  }
  open(options) {
    return __async$4(this, null, function* () {
      var _a;
      const id = options.id = (_a = options.id) != null ? _a : guid();
      (this.modals[id] = new Modal({ presenter: this, id })).open(options);
      this.updateBlindStatus();
    });
  }
  close() {
    return __async$4(this, arguments, function* ({ id } = {}) {
      var _a;
      let promise = null;
      if (id) {
        promise = (_a = this.modals[id]) == null ? void 0 : _a.close();
        delete this.modals[id];
      } else {
        promise = Promise.all(Object.values(this.modals).map((e) => e.close()));
        this.modals = {};
      }
      this.updateBlindStatus();
      yield promise;
    });
  }
  updateBlindStatus() {
    const open = Object.keys(this.modals).length > 0;
    document.body.classList.toggle("modal-open", open);
  }
}
class Modal {
  constructor({ presenter, id }) {
    this.presenter = presenter;
    this.id = id;
  }
  open(_0) {
    return __async$4(this, arguments, function* ({ size, url, close }) {
      const root = createElement(document.body, "modal");
      this.root = root;
      const content = createElement(root, "modal__content");
      const closeButton = createElement(content, "modal__close");
      closeButton.addEventListener("click", () => {
        this.presenter.close({ id: this.id });
      });
      const frame = createElement(content, "modal__frame");
      yield nextFrame();
      closeButton.style.display = (close != null ? close : true) ? "block" : "none";
      root.classList.add("modal--open");
      root.classList.add("modal--loading");
      root.classList.toggle("modal--small", size === "small");
      frame.innerHTML = yield getHTML(url);
      root.classList.remove("modal--loading");
    });
  }
  close() {
    return __async$4(this, null, function* () {
      const root = this.root;
      if (!root) {
        return;
      }
      root.classList.remove("modal--open");
      yield wait(1);
      root.remove();
      this.root = void 0;
    });
  }
}

var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class PopoverPresenter {
  constructor() {
    this.popovers = {};
    this.trackElement = (event) => {
      this.lastClickedElement = event.target;
    };
    document.addEventListener("click", this.trackElement);
  }
  open(options) {
    return __async$3(this, null, function* () {
      var _a, _b;
      const id = options.id = (_a = options.id) != null ? _a : "default-popover";
      options.selector = (_b = options.selector) != null ? _b : this.lastClickedElement;
      (this.popovers[id] = new Popover()).open(options);
    });
  }
  close() {
    return __async$3(this, arguments, function* ({ id } = {}) {
      var _a;
      let promise = null;
      if (id) {
        promise = (_a = this.popovers[id]) == null ? void 0 : _a.close();
        delete this.popovers[id];
      } else {
        promise = Promise.all(Object.values(this.popovers).map((e) => e.close()));
        this.popovers = {};
      }
      yield promise;
    });
  }
}
class Popover {
  constructor() {
    this.clickOutside = (event) => {
      var _a;
      if ((_a = this.popoverDiv) == null ? void 0 : _a.contains(event.target)) {
        return;
      }
      event.preventDefault();
      this.close();
    };
  }
  open(_0) {
    return __async$3(this, arguments, function* ({ url, selector, placement }) {
      const root = typeof selector === "string" ? document.querySelector(selector) : selector;
      if (!root) {
        return;
      }
      const popoverDiv = createElement(document.body, "popover");
      const arrow = createElement(popoverDiv, "popover__arrow");
      arrow.setAttribute("data-popper-arrow", "true");
      const content = createElement(popoverDiv, "popover__content");
      content.innerHTML = yield getHTML(url);
      this.popper = createPopper(root, popoverDiv, {
        placement: placement != null ? placement : "auto",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          }
        ]
      });
      this.popoverDiv = popoverDiv;
      document.addEventListener("click", this.clickOutside);
    });
  }
  close() {
    return __async$3(this, null, function* () {
      var _a, _b;
      (_a = this.popper) == null ? void 0 : _a.destroy();
      this.popper = void 0;
      document.removeEventListener("click", this.clickOutside);
      (_b = this.popoverDiv) == null ? void 0 : _b.remove();
      this.popoverDiv = void 0;
    });
  }
}

var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _consentListeners;
const consentCategories = ["essential", "targeting", "statistic"];
class Consent {
  constructor() {
    __privateAdd(this, _consentListeners, {
      essential: [],
      targeting: [],
      statistic: []
    });
  }
  get permitted() {
    var _a;
    return ((_a = getCookie("consent")) != null ? _a : "").split(",");
  }
  set permitted(settings) {
    setCookie("consent", settings.join(","));
    settings.forEach((category) => {
      __privateGet(this, _consentListeners)[category].forEach((e) => e());
    });
  }
  get given() {
    return getCookie("consent") !== void 0;
  }
  permitAll() {
    this.permitted = consentCategories.slice();
  }
  denyAll() {
    this.permitted = ["essential"];
  }
  showSettings() {
    const element = document.getElementById("personalization-settings");
    if (element)
      element.hidden = false;
  }
  consentFor(category) {
    return new Promise((res) => {
      if (this.permitted.includes(category)) {
        res();
      } else {
        __privateGet(this, _consentListeners)[category].push(res);
      }
    });
  }
  enableGoogleAnalytics(id, role = "statistic") {
    return __async$2(this, null, function* () {
      yield this.consentFor(role);
      window.gtag("js", new Date());
      window.gtag("config", id, { send_page_view: false });
      const script = document.createElement("script");
      script.async = true;
      script.setAttribute("src", `https://www.googletagmanager.com/gtag/js?id=${id}`);
      document.head.prepend(script);
    });
  }
}
_consentListeners = new WeakMap();

class RemoteNavigationController extends Controller {
  connect() {
    const script = this.element.innerText;
    (0, eval)(script);
    this.element.remove();
  }
}

class consent_default extends Controller {
  connect() {
    this.checkTargets.forEach((input) => {
      var _a;
      input.checked = ((_a = window.ui) == null ? void 0 : _a.consent.permitted.includes(input.name)) || input.name === "essential";
    });
  }
  permitAll(event) {
    var _a;
    event.preventDefault();
    (_a = window.ui) == null ? void 0 : _a.consent.permitAll();
    this.closeAll();
  }
  denyAll(event) {
    var _a;
    event.preventDefault();
    (_a = window.ui) == null ? void 0 : _a.consent.denyAll();
    this.closeAll();
  }
  save(event) {
    event.preventDefault();
    window.ui.consent.permitted = this.checkTargets.filter((e) => e.checked).map((e) => e.name);
    this.closeAll();
  }
  manage(event) {
    event.preventDefault();
    const div = document.body.querySelector("#personalization-settings");
    if (!div)
      return;
    this.element.hidden = true;
    div.hidden = false;
  }
  closeAll() {
    document.querySelectorAll("[data-controller='consent']").forEach((e) => e.hidden = true);
  }
}
consent_default.targets = ["check"];

var _a;
const dataLayer = window.dataLayer = (_a = window.dataLayer) != null ? _a : [];
function gtag(..._arg) {
  dataLayer.push(arguments);
}
window.gtag = gtag;
class AnalyticsController extends Controller {
  connect() {
    this.recordPage();
  }
  recordAction(event) {
    var _a2;
    const data = JSON.parse((_a2 = event.target.dataset.analytics) != null ? _a2 : "{}");
    const eventName = data["event"];
    delete data["event"];
    gtag("event", eventName, data);
  }
  recordPage() {
    gtag("event", "page_view", {
      page_title: document.title,
      page_location: document.location.toString()
    });
  }
}

document.addEventListener("turbo:load", () => {
  if (window.ontouchstart !== void 0) {
    document.body.classList.add("touch");
  } else {
    document.body.classList.add("no-touch");
  }
});
document.addEventListener("focusin", (event) => {
  const input = event.target;
  if (input.tagName === "INPUT" || input.tagName === "TEXTAREA") {
    document.body.classList.add("keyboard-visible");
  }
});
document.addEventListener("focusout", () => {
  document.body.classList.remove("keyboard-visible");
});

var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function registerServiceWorker() {
  return __async$1(this, null, function* () {
    if (navigator.serviceWorker) {
      yield navigator.serviceWorker.register("/serviceworker.js", {
        scope: "./"
      });
    }
  });
}

function currentLocale() {
  return document.documentElement.lang || "en";
}

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
window.ui = {
  modal: new ModalPresenter(),
  popover: new PopoverPresenter(),
  consent: new Consent()
};
function createRemoteDestination() {
  if (document.getElementById("shimmer")) {
    return;
  }
  const root = document.createElement("div");
  root.id = "shimmer";
  document.body.append(root);
}
function start(_0) {
  return __async(this, arguments, function* ({
    application
  }) {
    window.addEventListener("turbo:load", createRemoteDestination);
    createRemoteDestination();
    application.register("remote-navigation", RemoteNavigationController);
    application.register("consent", consent_default);
    application.register("analytics", AnalyticsController);
  });
}
const ui = window.ui;

export { currentLocale, registerServiceWorker, start, ui };
